import { useTranslation } from "react-i18next";
import { timezones } from "../../lib/schedule-time/schedule-dates";
import { timezoneLabel } from "../../lib/schedule-time/timezone-label";

export function VisualizerTimezonePicker({ value, onChange, date }: { value: string; onChange: (zone: string) => void; date: Date }) {
  const { t } = useTranslation();
  return (
    <label className="flex min-w-0 items-center gap-2 text-[11px] text-neutral-600">
      <span>{t("period.timezone")}</span>
      <select aria-label={t("visualizer.timezone")} value={value} onChange={event => onChange(event.target.value)}
        className="h-8 min-w-0 max-w-full rounded border border-neutral-300 bg-white px-2 font-mono text-xs text-neutral-900 focus-visible:outline-2 focus-visible:outline-neutral-900">
        {timezones.map(zone => <option key={zone} value={zone}>{timezoneLabel(zone, date, t)}</option>)}
      </select>
    </label>
  );
}
